import styled from '@emotion/styled';

export default styled('div')`
  margin: -4px;
  display: flex;
  flex-wrap: wrap;
  > * {
    margin: 4px;
  }
`;
